import { useEffect } from "react";

/**
 * Global delegated listener that fires GA4 + GTM events on every
 * tel:/sms: tap. Captures channel, page path, and CTA source.
 * No UI impact, zero footprint on layout.
 */
const fireEvent = (channel: "phone_call" | "sms_click", el: HTMLAnchorElement) => {
  const payload = {
    event: channel === "phone_call" ? "phone_call" : "sms_click",
    cta_source: el.dataset.cta || "untagged",
    page_path: window.location.pathname,
    page_location: window.location.href,
    link_href: el.href,
  };
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (typeof window.gtag === "function") {
      window.gtag("event", payload.event, {
        cta_source: payload.cta_source,
        page_path: payload.page_path,
      });
    }
  } catch {
    /* no-op */
  }
};

export const ClickToCallTracker = () => {
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target) return;
      const anchor = target.closest("a") as HTMLAnchorElement | null;
      if (!anchor || !anchor.href) return;
      if (anchor.href.startsWith("tel:")) fireEvent("phone_call", anchor);
      else if (anchor.href.startsWith("sms:")) fireEvent("sms_click", anchor);
    };
    document.addEventListener("click", handler, { capture: true });
    return () => document.removeEventListener("click", handler, { capture: true } as any);
  }, []);
  return null;
};

export default ClickToCallTracker;
